import { render, staticRenderFns } from "./LogsInstancesDatatable.vue?vue&type=template&id=95b6feec&scoped=true"
import script from "./LogsInstancesDatatable.vue?vue&type=script&lang=js"
export * from "./LogsInstancesDatatable.vue?vue&type=script&lang=js"
import style0 from "./LogsInstancesDatatable.vue?vue&type=style&index=0&id=95b6feec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b6feec",
  null
  
)

export default component.exports